<script>

import ForgotPasswordPageCcnsw from "@/views/auth/ccnsw/forgot_pass.vue";
import ForgotPasswordPageStw from "@/views/auth/statewide/forgot_pass.vue";
import ForgotPasswordPageDefault from "@/views/auth/default/forgot_pass.vue";
import {mapGetters} from "vuex";

export default {
  components: { ForgotPasswordPageDefault, ForgotPasswordPageCcnsw, ForgotPasswordPageStw},
  data () {
    return {
      host: '',
    }
  },
  methods: {},
  mounted () {
    this.host = window.location.hostname
  },
  computed: {
    ...mapGetters({
      isStatewide: 'isStatewide'
    }),
    isCCNSW () {
      return (this.host == 'ccnsw.stg.partssearch.com.au')
    },
  }
}
</script>

<template>
  <forgot-password-page-ccnsw v-if="isCCNSW"></forgot-password-page-ccnsw>
  <forgot-password-page-stw v-else-if="isStatewide"></forgot-password-page-stw>
  <forgot-password-page-default v-else></forgot-password-page-default>
</template>
